// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.form-control{
    width: 100%;
    height: 70px;
    border-radius: 15px;
    border: 1px solid #215D88;
    margin-bottom: 24px;
    position: relative;
 }
 h1{
    font-size: 32px;
    color: white;
    font-weight: 600;
 }
 h3{
   font-size: 24px;
   color: white;
   font-weight: 300;
}
.stu{
   position: absolute;
   top: 0;
   right: 0;
   width: 42%;
   /* z-index: 7777; */
   }
.bg-2{
   background-color: #F2F2F2;
   margin-bottom: 80px;
}
.pearson{
   background-color: #ED7D31;
   border: none;
   padding: 12px 28px;
   border-radius: 16px;
   color: white;
   font-size: 24px;
   font-weight: 600;
   box-shadow: 10px 13px 20px #00000029;
}
.verify{
   background-color: #707070;
   border: 1px solid #707070;
   padding: 10px 16px;
   border-radius: 6px;
   color: white;
   font-size: 16px;
   font-weight: 600;
   box-shadow: 10px 13px 20px #00000029;
   cursor: pointer;
   position: absolute;
   right: 24px;
   top: 12px;
}
.btn-waitlist{
   padding: 24px 120px;
   background: #0070C0;
   border: none;
   border-radius: 62px;
}
.code{
   color: #3AA1D5;
   font-size: 28px;
   margin: 0 12px;
}
.promo{
   position: absolute;
   left: 36px;
   top: 24px;
   color: #ED7D31;
   font-size: 16px;
   cursor: pointer;
   font-weight: 600;
}
h2{
   color: #3AA1D5;
   margin: 0;
   font-weight: 600;
}
.stu-mob{
   position: relative;
   top: 110px;
   text-align: center;
}
 /* .navbar-brand{
    background-color: #215D88;
    width: 25%;
    text-align: left;
    margin: 1rem 0;
 }
 p,span{
    color: #215D88;
 }
 i{
    font-size: 20px;
    color: #215D88;
 }
 button{
    border-radius: 13px;
    border: 1px solid #215D88;
    padding: 8px 12px; 
    background: #215D88 0% 0% no-repeat padding-box;
 }
 .radiobtn label {
    display: block;
    background: white;
    border-radius: 13px;
    padding: 8px 28px;
    border: 1px solid #215D88;
    margin: 4px;
    cursor: pointer;
    font-size: 16px;
    box-shadow: 0px 4px 16px #215D8852;
 }
 .radiobtn input[type="radio"]  {
    display: none;
    position: absolute;
    width: 100%;
    appearance: none;
 }
 .radiobtn input[type="radio"]:checked + label {
    background: #215D88;
    animation-name: blink;
    animation-duration: 1s;
    border-color:#215D88;
    color: white;
    box-shadow: none;
 }
 .carousel-indicators li{
    background-color: #215D88 !important;
    width: 10px;
    height: 10px;
    border-radius: 100%;
 }
 .carousel-indicators{
    top: 90%;
 }
 i:focus{
    outline: none;
 }
 .w-90{
    width: 90%;
 }
 form{
    padding-left: 3rem;
 }
 .waitlist{
     margin-top: 10%;
 }
 .btn-waitlist{
    padding: 10 1rem;
    background: #ed7c30;
    border: none;
    border-radius: 10px;
 }
 .select{
    position: relative;
    bottom: 10px;
    width: 80%;
 }
 @media screen and (max-width:768px){
    h1{
       font-size: 24px;
       text-align: center;
    }
    form{
       padding-left: 2px;
    }
    .navbar-brand{
       margin-top: 0;
       margin-bottom: 2rem;
    }
    .form-control{
       width: 100%;
       height: 40px;
    }
    .radiobtn label{
       padding: 4px 24px;
        text-align: center;
    }
 } */

 @media screen and (max-width:768px){
   .front{
      margin-top: 60px !important;
   }
   h1{
      font-size: 24px;
      text-align: left;
   }
   h2,.code{
     font-size: 20px;
   }
   .pearson{
      font-size: 18px;
   }
   .stu {
      position: absolute;
      top: 100px;
      right: 0;
      width: 42%;
  }
  .stu-mob {
   position: relative;
   top: 30px;
   text-align: center;
   }
   h3{
      text-align: left;
      font-size: 22px;
   }
 }
 .front{
   margin-top: 80px;
    /* background-color: #1b57d9; */
    background-image: url(/assets/images/wait.svg);
}
.was-validated .form-control:valid {
   border-color: #28a745 !important;}`, "",{"version":3,"sources":["webpack://./src/app/waitlist/waitlist.component.css"],"names":[],"mappings":";AACA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,kBAAkB;CACrB;CACA;IACG,eAAe;IACf,YAAY;IACZ,gBAAgB;CACnB;CACA;GACE,eAAe;GACf,YAAY;GACZ,gBAAgB;AACnB;AACA;GACG,kBAAkB;GAClB,MAAM;GACN,QAAQ;GACR,UAAU;GACV,mBAAmB;GACnB;AACH;GACG,yBAAyB;GACzB,mBAAmB;AACtB;AACA;GACG,yBAAyB;GACzB,YAAY;GACZ,kBAAkB;GAClB,mBAAmB;GACnB,YAAY;GACZ,eAAe;GACf,gBAAgB;GAChB,oCAAoC;AACvC;AACA;GACG,yBAAyB;GACzB,yBAAyB;GACzB,kBAAkB;GAClB,kBAAkB;GAClB,YAAY;GACZ,eAAe;GACf,gBAAgB;GAChB,oCAAoC;GACpC,eAAe;GACf,kBAAkB;GAClB,WAAW;GACX,SAAS;AACZ;AACA;GACG,mBAAmB;GACnB,mBAAmB;GACnB,YAAY;GACZ,mBAAmB;AACtB;AACA;GACG,cAAc;GACd,eAAe;GACf,cAAc;AACjB;AACA;GACG,kBAAkB;GAClB,UAAU;GACV,SAAS;GACT,cAAc;GACd,eAAe;GACf,eAAe;GACf,gBAAgB;AACnB;AACA;GACG,cAAc;GACd,SAAS;GACT,gBAAgB;AACnB;AACA;GACG,kBAAkB;GAClB,UAAU;GACV,kBAAkB;AACrB;CACC;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;IAgGG;;CAEH;GACE;MACG,2BAA2B;GAC9B;GACA;MACG,eAAe;MACf,gBAAgB;GACnB;GACA;KACE,eAAe;GACjB;GACA;MACG,eAAe;GAClB;GACA;MACG,kBAAkB;MAClB,UAAU;MACV,QAAQ;MACR,UAAU;EACd;EACA;GACC,kBAAkB;GAClB,SAAS;GACT,kBAAkB;GAClB;GACA;MACG,gBAAgB;MAChB,eAAe;GAClB;CACF;CACA;GACE,gBAAgB;IACf,+BAA+B;IAC/B,8CAA8C;AAClD;AACA;GACG,gCAAgC,CAAC","sourcesContent":["\n.form-control{\n    width: 100%;\n    height: 70px;\n    border-radius: 15px;\n    border: 1px solid #215D88;\n    margin-bottom: 24px;\n    position: relative;\n }\n h1{\n    font-size: 32px;\n    color: white;\n    font-weight: 600;\n }\n h3{\n   font-size: 24px;\n   color: white;\n   font-weight: 300;\n}\n.stu{\n   position: absolute;\n   top: 0;\n   right: 0;\n   width: 42%;\n   /* z-index: 7777; */\n   }\n.bg-2{\n   background-color: #F2F2F2;\n   margin-bottom: 80px;\n}\n.pearson{\n   background-color: #ED7D31;\n   border: none;\n   padding: 12px 28px;\n   border-radius: 16px;\n   color: white;\n   font-size: 24px;\n   font-weight: 600;\n   box-shadow: 10px 13px 20px #00000029;\n}\n.verify{\n   background-color: #707070;\n   border: 1px solid #707070;\n   padding: 10px 16px;\n   border-radius: 6px;\n   color: white;\n   font-size: 16px;\n   font-weight: 600;\n   box-shadow: 10px 13px 20px #00000029;\n   cursor: pointer;\n   position: absolute;\n   right: 24px;\n   top: 12px;\n}\n.btn-waitlist{\n   padding: 24px 120px;\n   background: #0070C0;\n   border: none;\n   border-radius: 62px;\n}\n.code{\n   color: #3AA1D5;\n   font-size: 28px;\n   margin: 0 12px;\n}\n.promo{\n   position: absolute;\n   left: 36px;\n   top: 24px;\n   color: #ED7D31;\n   font-size: 16px;\n   cursor: pointer;\n   font-weight: 600;\n}\nh2{\n   color: #3AA1D5;\n   margin: 0;\n   font-weight: 600;\n}\n.stu-mob{\n   position: relative;\n   top: 110px;\n   text-align: center;\n}\n /* .navbar-brand{\n    background-color: #215D88;\n    width: 25%;\n    text-align: left;\n    margin: 1rem 0;\n }\n p,span{\n    color: #215D88;\n }\n i{\n    font-size: 20px;\n    color: #215D88;\n }\n button{\n    border-radius: 13px;\n    border: 1px solid #215D88;\n    padding: 8px 12px; \n    background: #215D88 0% 0% no-repeat padding-box;\n }\n .radiobtn label {\n    display: block;\n    background: white;\n    border-radius: 13px;\n    padding: 8px 28px;\n    border: 1px solid #215D88;\n    margin: 4px;\n    cursor: pointer;\n    font-size: 16px;\n    box-shadow: 0px 4px 16px #215D8852;\n }\n .radiobtn input[type=\"radio\"]  {\n    display: none;\n    position: absolute;\n    width: 100%;\n    appearance: none;\n }\n .radiobtn input[type=\"radio\"]:checked + label {\n    background: #215D88;\n    animation-name: blink;\n    animation-duration: 1s;\n    border-color:#215D88;\n    color: white;\n    box-shadow: none;\n }\n .carousel-indicators li{\n    background-color: #215D88 !important;\n    width: 10px;\n    height: 10px;\n    border-radius: 100%;\n }\n .carousel-indicators{\n    top: 90%;\n }\n i:focus{\n    outline: none;\n }\n .w-90{\n    width: 90%;\n }\n form{\n    padding-left: 3rem;\n }\n .waitlist{\n     margin-top: 10%;\n }\n .btn-waitlist{\n    padding: 10 1rem;\n    background: #ed7c30;\n    border: none;\n    border-radius: 10px;\n }\n .select{\n    position: relative;\n    bottom: 10px;\n    width: 80%;\n }\n @media screen and (max-width:768px){\n    h1{\n       font-size: 24px;\n       text-align: center;\n    }\n    form{\n       padding-left: 2px;\n    }\n    .navbar-brand{\n       margin-top: 0;\n       margin-bottom: 2rem;\n    }\n    .form-control{\n       width: 100%;\n       height: 40px;\n    }\n    .radiobtn label{\n       padding: 4px 24px;\n        text-align: center;\n    }\n } */\n\n @media screen and (max-width:768px){\n   .front{\n      margin-top: 60px !important;\n   }\n   h1{\n      font-size: 24px;\n      text-align: left;\n   }\n   h2,.code{\n     font-size: 20px;\n   }\n   .pearson{\n      font-size: 18px;\n   }\n   .stu {\n      position: absolute;\n      top: 100px;\n      right: 0;\n      width: 42%;\n  }\n  .stu-mob {\n   position: relative;\n   top: 30px;\n   text-align: center;\n   }\n   h3{\n      text-align: left;\n      font-size: 22px;\n   }\n }\n .front{\n   margin-top: 80px;\n    /* background-color: #1b57d9; */\n    background-image: url(/assets/images/wait.svg);\n}\n.was-validated .form-control:valid {\n   border-color: #28a745 !important;}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
